export default __webpack_public_path__ + "static/exp2-69619a8818bb1f485aaee97999aa2a25.jpg";